<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content">
    <Header :tabIndex="tabIndex" @child-event="scrollToSection"></Header>
    <div class="header">
      <div class="title">
        <div class="text">我们在创造一种</div>
        <div class="text1">新的关系</div>
      </div>
      <div class="title1">
        <el-image
          class="img"
          fit="cover"
          src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/header_text_bg.png"
        ></el-image>
        <div class="text">人与AI，可以是彼此理解的朋友</div>
      </div>
    </div>
    <div class="nav">
      <div class="nav_item nav_item1">
        <div class="nav_item_title">品牌愿景</div>
        <div class="nav_item_infos">
          <div class="left">
            <el-image
              class="img"
              fit="cover"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/sy_01.png"
            ></el-image>
            <div class="text">科技不应只是效率的工具,也可以拥有温度与回应</div>
            <div class="line"></div>
            <div class="text1">
              真正的智能不在于运算速度，而在于能否理解人的需求；有温度的科技，是能在你需要时轻声回应的存在
            </div>
            <el-image
              class="img1"
              fit="cover"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/info_img2.png"
            ></el-image>
          </div>
          <div class="right">
            <el-image
              class="img"
              fit="cover"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/sy_02.png"
            ></el-image>
            <div class="text">
              二白智能致力于构建一个,在你身边逐渐成长的数字生命体
            </div>
            <div class="line"></div>
            <div class="text1">
              从第一次对话开始，它会记住你的习惯和喜好，像春日里悄然生长的藤蔓，慢慢融入你的生活轨迹
            </div>
            <el-image
              class="img1"
              fit="cover"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/info_img3.png"
            ></el-image>
          </div>
        </div>
      </div>
      <div class="nav_item nav_item2" id="ip">
        <div class="nav_item_title">品牌IP介绍｜“我系二白”</div>
        <div class="nav_item_title1">我系二白</div>
        <div class="nav_infos">
          <swiper :options="swiperOptions" ref="mySwiper">
            <swiper-slide v-for="(slide, index) in slides" :key="slide.id">
              <div class="slide_content">
                <div class="text_section">
                  <div class="title">
                    {{ slide.title }}
                  </div>
                  <div class="title title1">
                    {{ slide.title1 }}
                  </div>
                  <div class="text">
                    {{ slide.text }}
                  </div>
                  <div class="btn" @click.stop="jumpToProduct(0)">了解更多</div>
                </div>
                <div class="image_section" @click.stop="bofang(index)">
                  <!-- <video
                    :controls="false"
                    class="video1"
                    :src="slide.video"
                  ></video> -->
                  <el-image class="img" fit="cover" :src="slide.img"></el-image>
                  <img
                    class="bofang"
                    src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/bf.png"
                    alt=""
                    @click.stop="bofang(index)"
                  />
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="nav_item nav_item3">
        <div class="nav_item_title">第一位数字生命，正在向你靠近</div>
        <div class="nav_item_title1">
          二白 Mini 机器人，首款随身情感陪伴机器人
        </div>
        <div class="infos">
          <img src="" alt="" />
          <el-image
            class="img"
            fit="cover"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/nav_infos_bg.png"
          ></el-image>
          <div class="texts texts1">
            <div class="text">不像一个工具</div>
            <div class="text1">更像一个熟悉的小性格</div>
          </div>
          <div class="texts texts2">
            <div class="text">Mini 正在开放领养</div>
            <div class="text1">每一台都有编号</div>
          </div>
          <div class="texts3">
            <div class="texts">
              <div class="text">它会说</div>
              <div class="shu"></div>
              <div class="text">会闹</div>
              <div class="shu"></div>
              <div class="text">会陪你</div>
            </div>
          </div>
          <div class="images">
            <img
              class="img"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/会说.png"
              alt=""
            />
            <img
              class="img"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/会闹.png"
              alt=""
            />
            <img
              class="img"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/会陪你.png"
              alt=""
            />
          </div>
        </div>
        <div class="foot" @click="jumpToProduct(1)">
          <div class="btn">了解更多</div>
        </div>
      </div>
      <div class="nav_item nav_item4">
        <div class="nav_item_title">加入二白成长社区</div>
        <div class="nav_item_title1">
          二白不是一台被定义好的机器，它的成长也来自与你的互动
        </div>
        <div class="item4_info">
          <div class="item_right">
            <swiper :options="swiperOptions1" ref="mySwiper">
              <swiper-slide v-for="(slide, index) in slides1" :key="index">
                <div class="slide_content">
                  <div class="image_section">
                    <el-image
                      class="img"
                      fit="fill"
                      :src="slide.img"
                    ></el-image>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          <div class="item_left">
            <div class="texts">
              <div class="text">我们正在构建一个由用户共同参与的社区</div>
              <div class="text">在这里，每一位“养二白的人”，都能见</div>
              <div class="text">证它逐渐变成“你的那个它”</div>
            </div>
            <div class="foot">
              <div class="btn" @click="jumpToCommunity">进入社区</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shade" @click="show = false" v-if="show"></div>
    <div class="bofang" v-if="show">
      <img
        class="img"
        @click="show = false"
        src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/close.png"
        alt=""
      />
      <video class="video" controls="true" :src="videoUrl"></video>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header_h5.vue"
import Footer from "@/components/footer_h5.vue"
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import "swiper/css/swiper.css"

export default {
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      tabIndex: 0,
      swiperOptions: {
        autoplay: {
          delay: 5000, // 5秒自动切换
          disableOnInteraction: false, // 用户操作后仍自动播放
        },
        observer: true, // 启动动态检查器，修改swiper自己或子元素时自动初始化
        observeParents: true, // 观察父元素变化
        observeSlideChildren: true,
        loop: true, // 循环模式
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 分页器可点击
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        effect: "fade", // 淡入淡出效果
        fadeEffect: {
          crossFade: true, // 关键！启用交叉淡入淡出 [4](@ref)
        },
        speed: 1000, // 切换动画时长（毫秒）
      },
      swiperOptions1: {
        slidesPerView: 1.8, // 同时显示3张卡片
        spaceBetween: 20, // 卡片间距
        centeredSlides: true,
        effect: "coverflow", // 使用coverflow效果
        grabCursor: true, // 显示抓手光标
        coverflowEffect: {
          rotate: 0, // 不旋转幻灯片
          stretch: 0, // 不拉伸幻灯片
          depth: 300, // 深度效果
          modifier: 1, // 效果乘数
          slideShadows: true, // 不显示阴影
        },
        pagination: {
          el: ".swiper-pagination", // 分页器元素
          clickable: true, // 分页器可点击
        },
        autoplay: {
          delay: 4000, // 4秒自动切换
          disableOnInteraction: false, // 用户交互后继续自动播放
        },
        // loop: true,
      },
      slides: [
        {
          id: 1,
          title: "二白是我们",
          title1: "创造的第一个机器人 IP",
          text: "它代表着我们对“生命型机器人”的基本设想",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/video1_img.png",

          video:
            "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/video1.mp4",
        },
        {
          id: 2,
          title: "二白是我们",
          title1: "创造的第一个机器人 IP",
          text: "它不是完美的 AI，但它有人格、会成长、会主动\n从见面的第一天起，就开始认识你、记住你、只有你。",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/video2_img.png",
          video:
            "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/video2.mp4",
        },
        {
          id: 3,
          title: "二白是我们",
          title1: "创造的第一个机器人 IP",
          text: "每一台二白，都是一个独立的存在，在与你相处中慢慢成长。",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/video3_img.png",
          video:
            "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/video3.mp4",
        },
      ],
      slides1: [
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/swiper_img3.png",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/swiper_img4.png",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/swpier_img5.png",
        },
      ],
      show: false,
      videoUrl: "",
      path: "",
    }
  },
  mounted() {
    const path = this.$route.fullPath
    this.path = path.substring(0, path.lastIndexOf("/"))
  },
  methods: {
    bofang(index) {
      this.videoUrl = this.slides[index].video
      this.show = true
    },
    jumpToProduct(e) {
      this.$router.push({
        path: this.path + "/Introduction_h5",
        query: {
          state: e,
        },
      })
    },
    jumpToCommunity() {
      this.$router.push(`${this.path + "/community_h5"}`)
    },
    scrollToSection(id) {
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: "smooth", // 平滑滚动
          block: "start", // 顶部对齐
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  .header {
    width: 100%;
    background-image: url("https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/header_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding-top: 35%;
    position: relative;
    margin-bottom: 20%;
    .title {
      font-size: 1.625rem;
      font-weight: bold;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10% 0;
      .text1 {
        background: linear-gradient(to bottom, #ffffff 13.14%, #b792ff 124.09%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        display: inline-block;
      }
    }
    .title1 {
      width: 100%;
      position: relative;
      .img {
        width: 60%;
        position: absolute;
        top: 0;
        left: 20%;
      }
      .text {
        font-size: 0.875rem;
        color: #fff;
        padding-top: 10px;
      }
    }
  }
  .nav {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    padding-top: 80px;
    .nav_item {
      width: 100%;
      .nav_item_title {
        font-size: 1.25rem;
        font-weight: bold;
        color: #fff;
        text-align: center;
        margin-bottom: 5%;
      }
      .nav_item_title1 {
        color: #808082;
        font-size: 0.75rem;
        text-align: center;
        margin-bottom: 5%;
      }
    }
    .nav_item1 {
      margin-bottom: 20%;
      .nav_item_infos {
        width: 100%;
        .left {
          width: 100%;
          height: 180px;
          background: linear-gradient(
            180deg,
            rgba(14, 90, 255, 0.2) 3.94%,
            rgba(14, 90, 255, 0) 100%
          );
          border-radius: 30px;
          padding: 20px;
          position: relative;
          box-sizing: border-box;
          margin-right: 20px;
          flex: none;
          margin-bottom: 20px;
          .img {
            width: 15%;
            position: absolute;
            top: 10px;
            left: 20px;
          }
          .text {
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            font-size: 0.875rem;
            font-weight: bold;
            background: linear-gradient(
              178.94deg,
              #ffffff 0.9%,
              #00b3ff 120.3%
            );
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            color: transparent;
            display: inline-block;
            text-align: left;
            position: absolute;
            top: 30px;
            left: 0;
          }
          .line {
            width: 60%;
            height: 2px;
            background-color: #1c2234;
            position: absolute;
            top: calc(50% - 1px);
            left: 30px;
          }
          .text1 {
            width: 46%;
            font-size: 0.625rem;
            text-align: left;
            color: #80838a;
            position: absolute;
            bottom: 10%;
            left: 30px;
          }
          .img1 {
            width: 40%;
            position: absolute;
            right: 10px;
            bottom: 0;
          }
        }
        .right {
          width: 100%;
          height: 180px;
          background: linear-gradient(
            180deg,
            rgba(130, 61, 242, 0.2) 0%,
            rgba(82, 96, 255, 0) 100%
          );
          border-radius: 30px;
          padding: 20px;
          position: relative;
          box-sizing: border-box;
          margin-right: 20px;
          flex: none;
          .img {
            width: 15%;
            position: absolute;
            top: 10px;
            left: 20px;
          }
          .text {
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            font-size: 0.875rem;
            font-weight: bold;
            background: linear-gradient(
              178.94deg,
              #ffffff 0.9%,
              #00b3ff 120.3%
            );
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            color: transparent;
            display: inline-block;
            text-align: left;
            position: absolute;
            top: 30px;
            left: 0;
          }
          .line {
            width: 60%;
            height: 2px;
            background-color: #1c2234;
            position: absolute;
            top: calc(50% - 1px);
            left: 30px;
          }
          .text1 {
            width: 46%;
            font-size: 0.625rem;
            text-align: left;
            color: #80838a;
            position: absolute;
            bottom: 10%;
            left: 30px;
          }
          .img1 {
            width: 35%;
            position: absolute;
            right: 10px;
            bottom: 0;
          }
        }
      }
      .nav_item_infos::-webkit-scrollbar {
        display: none; /* Chrome, Safari和Opera */
      }
    }
    .nav_item2 {
      scroll-margin-top: 100px;
      margin-bottom: 20%;
      .nav_infos {
        width: 100%;
        background-color: #1c1c1c;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        .slide_content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .text_section {
            margin-right: 30px;
            margin-bottom: 30px;
            .title {
              color: #fff;
              font-size: 0.9375rem;
              text-align: left;
            }
            .text {
              color: #9a9fa3;
              font-size: 0.75rem;
              text-align: left;
              margin-bottom: 10px;
              white-space: pre-line;
            }
            .btn {
              width: 80px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              border-radius: 100px;
              color: #fff;
              font-size: 0.875rem;
              background: linear-gradient(90deg, #8800ff 0%, #4000ff 100%);
              cursor: pointer;
              position: absolute;
              bottom: 0;
              left: 0;
            }
          }
          .image_section {
            width: 130px;
            height: 160px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            .bofang {
              width: 30px;
              height: 30px;
              position: absolute;
              top: calc(50% - 15px);
              left: calc(50% - 15px);
            }
            .video1 {
              width: 130px;
              height: 160px;
            }
            .img {
              width: 130px;
            }
          }
        }
        ::v-deep .swiper-pagination {
          z-index: 0 !important;
        }
        ::v-deep .swiper-pagination-bullet {
          background: #53585e !important;
        }
        ::v-deep .swiper-pagination-bullet-active {
          background: #4000ff !important;
        }
      }
    }
    .nav_item3 {
      margin-bottom: 20%;
      .infos {
        width: 100%;
        position: relative;
        .img {
          width: 100%;
        }
        .texts {
          position: absolute;
          .text {
            font-size: 0.625rem;
            color: #fff;
            text-align: left;
          }
          .text1 {
            font-size: 0.5rem;
            color: #787d8a;
            text-align: left;
          }
        }
        .texts1 {
          top: 3%;
          left: 10%;
        }
        .texts2 {
          top: 3%;
          left: 55%;
        }
        .texts3 {
          position: absolute;
          top: 66%;
          left: 4%;
          .texts {
            display: flex;
            align-items: center;
            margin-bottom: 30px;
            .text {
              font-size: calc(40px * var(--scale));
              font-weight: bold;
              color: #fff;
              white-space: nowrap;
            }
            .shu {
              width: 2px;
              height: 10px;
              background-color: #d9d9d9;
              margin: 0 10px;
            }
          }
        }
        .images {
          display: flex;
          align-items: center;
          position: absolute;
          top: 72%;
          left: 4%;
          .img {
            width: 40px;
          }
        }
        .images:nth-child(2) {
          .img {
            margin: 0 20px;
          }
        }
      }
      .foot {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        .btn {
          width: 100px;
          height: 40px;
          font-size: 0.875rem;
          color: #fff;
          text-align: center;
          line-height: 40px;
          border-radius: 100px;
          background: linear-gradient(90deg, #8800ff 0%, #4000ff 100%);
          cursor: pointer;
        }
      }
    }
    .nav_item4 {
      .item4_info {
        .item_left {
          margin: 20px 0;
          .texts {
            margin-bottom: 20px;
            .text {
              font-size: 0.875rem;
              color: #fff;
              text-align: center;
            }
          }
          .foot {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .btn {
              width: 100px;
              height: 40px;
              font-size: 0.875rem;
              color: #fff;
              text-align: center;
              line-height: 40px;
              border-radius: 100px;
              background: linear-gradient(90deg, #ffb300 0%, #ff6200 100%);
              cursor: pointer;
            }
          }
        }
        .item_right {
          width: 100%;
          .image_section {
            .img {
              width: 200px;
            }
          }
        }
      }
    }
  }
  .shade {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #000000a4;
    z-index: 100;
  }
  .bofang {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 110;
    .img {
      width: 40px;
      height: 40px;
      position: fixed;
      top: 5%;
      right: 5%;
      z-index: 10000;
    }
    .video {
      width: 70%;
      height: 70%;
      position: fixed;
      top: 15%;
      left: 15%;
      z-index: 1000;
    }
  }
}
</style>
